// extracted by mini-css-extract-plugin
module.exports = {"region":"product-details_region__5HQkH","stack":"product-details_stack__1mdLV","cluster":"product-details_cluster__ak85B"};